<template>
    <section class="page-auth-tenantselect">
        <header>
            <DIcon
                name="domain"
                :size="64"
            />
            <h1>{{ __('messages.tenant.select.title') }}</h1>
        </header>

        <div class="tenants">
            <TenantItem
                v-for="tenant in activeTenants"
                :id="'tenant-'+tenant.id"
                :key="tenant.id"
                :logo="tenant.logo"
                :logo-dark="tenant.logo_dark"
                :active="tenant.active"
                :company-name="tenant.company_name"
                :selected="selectedId === tenant.id"
                @click="changeSelection(tenant.id)"
            />
        </div>

        <DCard
            v-if="showHidden"
            padding
            class="advanced-header"
        >
            <h1>{{ __('messages.tenant.select.advanced_title') }}</h1>
            <p>{{ __('messages.tenant.select.advanced_body') }}</p>
        </DCard>

        <div
            v-if="showHidden"
            class="tenants"
        >
            <TenantItem
                v-for="tenant in inactiveTenants"
                :id="'tenant-'+tenant.id"
                :key="tenant.id"
                :company-name="tenant.company_name"
                :active="tenant.active"
                :selected="selectedId === tenant.id"
                @click="changeSelection(tenant.id)"
            />
        </div>

        <div class="actions">
            <DButton
                id="tenant-confirm"
                name="tenant-confirm"
                :disabled="selectedId === ''"
                :label="__('messages.tenant.select.select_and_continue')"
                @click="confirmSelection"
            />
        </div>
    </section>
</template>

<script>
import AuthBase from '~@/Pages/Login/AuthBase'
import TenantItem from '~@/Components/App/Tenant/TenantItem'

export default {
    name: 'TenantSelect',
    components: {
        TenantItem
    },
    layout: AuthBase,
    props: {
        tenants: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {
            selectedId: '',
            showHidden: false
        }
    },
    computed: {
        activeTenants () {
            return this.tenants.filter((value) => {
                return value.active
            })
        },
        inactiveTenants () {
            return this.tenants.filter((value) => {
                return !value.active
            })
        }
    },
    mounted () {
        document.addEventListener('keydown', this.checkAdvancedMode)
        document.addEventListener('keypress', this.checkAdvancedMode)
        document.addEventListener('keyup', this.checkAdvancedMode)
    },
    beforeUnmount () {
        document.removeEventListener('keydown', this.checkAdvancedMode)
        document.removeEventListener('keypress', this.checkAdvancedMode)
        document.removeEventListener('keyup', this.checkAdvancedMode)
    },
    methods: {
        changeSelection (tenantId) {
            this.selectedId = tenantId
        },
        confirmSelection () {
            this.$inertia.get(this.$route('tenant.set', { tenant: this.selectedId }))
        },
        checkAdvancedMode (e) {
            if (e.shiftKey && e.key === 'H') {
                this.showHidden = !this.showHidden
            }
        }
    }
}
</script>

<style lang="scss" scoped>
header {
    text-align: center;

    & .mdi {
        margin-bottom: 10px;
        color: #f5c844;
    }
    & h1 {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 25px;
    }
}
.tenants {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 25px;
    margin: 25px 0px;
}
.advanced-header {
    & h1 {
        font-size: 20px;
        margin: 0 0 10px;
    }
    & p {
        color: rgba(0,0,0,0.6);
        margin: 0;
    }
}
.actions {
    text-align: center;
}
</style>
